import password_rejected from './password-rejected.js';
const error = {
    general_required: '{{types, list(type: disjunction;)}}必填',
    general_invalid: '無效的{{types, list(type: disjunction;)}}',
    invalid_min_max_input: '輸入值應該在 {{minValue}} 和 {{maxValue}} 之間',
    invalid_min_max_length: '輸入值的長度應該在 {{minLength}} 和 {{maxLength}} 之間',
    username_required: '用戶名必填',
    password_required: '密碼必填',
    username_exists: '用戶名已存在',
    username_should_not_start_with_number: '用戶名不能以數字開頭',
    username_invalid_charset: '用戶名只能包含英文字母、數字或下劃線。',
    username_too_short: '用戶名必須至少有 {{min}} 個字符。',
    username_too_long: '用戶名最多只能有 {{max}} 個字符。',
    username_uppercase_not_allowed: '用戶名不允許使用大寫字母。',
    username_lowercase_not_allowed: '用戶名不允許使用小寫字母。',
    username_numbers_not_allowed: '用戶名不允許使用數字。',
    username_underscore_not_allowed: '用戶名不允許使用下劃線。',
    invalid_email: '無效的電子郵件',
    invalid_phone: '無效的手機號碼',
    passwords_do_not_match: '兩次輸入的密碼不一致。',
    invalid_passcode: '無效的驗證碼。',
    device_code_required: '請輸入代碼。',
    invalid_device_code: '裝置代碼無效。',
    device_flow_aborted: '登錄請求已中斷。',
    invalid_connector_auth: '登錄失敗',
    invalid_connector_request: '無效的登錄請求',
    unknown: '未知錯誤，請稍後重試。',
    invalid_session: '未找到會話，請返回並重新登錄。',
    timeout: '請求超時，請稍後重試。',
    password_rejected,
    sso_not_enabled: '此電子郵件帳戶未啟用單一登錄。',
    invalid_link: '無效的鏈接',
    invalid_link_description: '你的一次性令牌可能已過期或失效。',
    captcha_verification_failed: '驗證碼驗證失敗。',
    send_verification_code_failed: '驗證碼傳送失敗，請稍後再試。',
    send_verification_code_failed_use_password: '驗證碼傳送失敗，請改用密碼登錄。',
    terms_acceptance_required: '需要同意條款',
    terms_acceptance_required_description: '必須同意條款後才能繼續。',
    something_went_wrong: '出錯了',
    account_suspended: '帳戶已停用',
    account_suspended_description: '此帳戶已被停用，請聯絡管理員以取得協助。',
    access_denied: '拒絕訪問',
    application_access_denied: '您沒有權限訪問此應用。\n請聯繫管理員尋求幫助。',
    feature_not_enabled: '您沒有權限訪問此功能。請聯繫管理員尋求幫助。',
    wallet_not_found: '未偵測到以太坊錢包。請安裝瀏覽器錢包擴充功能後重試。',
    wallet_not_supported: '錢包登入僅支援已安裝錢包擴充功能的瀏覽器。',
    wallet_request_rejected: '錢包請求已被拒絕，請重試。',
    wallet_unsupported_chain: '錢包連接了不支援的網絡，請切換網絡後重試。',
    wallet_signature_invalid: '錢包簽名無效或已過期，請重試。',
};
export default Object.freeze(error);
